import { createAuthenticatedHttpClient } from 'src/modules/seek-api-request';

export const isAuthenticated = async () => {
  try {
    return (await createAuthenticatedHttpClient().getToken()).authenticated;
  } catch (_: unknown) {
    return false;
  }
};
